export default __webpack_public_path__ + "media/images/hero-standards-preloved.jpg";